import BaseLayer from "./BaseLayer";
import {drawRectangle, getNorthBounds, getWestBounds} from "../utils/map_utils";
import {hsvToRgb, notNull} from "../../../utils/utils";

/**
 * Per-seam residual magnitude from seam_distortion_diagnostic.py.
 * Draws a heat-coloured square on the WEST edge (vertical / LR seams) and the
 * NORTH edge (horizontal / TB seams) of each tile, scaled by |residual|.
 * Mirrors the "Stitching Error" overlay, but uses the seam diagnostic output.
 */
class SeamDistortion extends BaseLayer {
    id = "seamDistortion";
    label = "Seam Dist";
    defaultVisible = this.props.tileViewerState[this.id];

    colorFor = (mag, minV, maxV) => {
        let frac = (maxV > minV) ? (mag - minV) / (maxV - minV) : 0;
        frac = Math.max(0, Math.min(1, frac));
        // green (low) -> red (high)
        let {r, g, b} = hsvToRgb(0.33 * (1 - frac), 1, 1);
        return `rgba(${r},${g},${b},0.85)`;
    };

    draw = () => new Promise((resolve) => {
        let {seamDistortion, slide, textColor} = this.props;
        if (!notNull(seamDistortion)) return resolve();

        let {tile_width, tile_height, uperpixel, y_fields} = slide;
        let tw = tile_width * uperpixel, th = tile_height * uperpixel;
        let margin = 3 / 10, sizeOfMarker = 0.2;

        let stats = seamDistortion.stats || {};
        let minV = notNull(stats.min) ? stats.min : 0;
        let maxV = notNull(stats.p95) ? stats.p95 : (notNull(stats.max) ? stats.max : 1);

        let plot = (mapObj, isTop) => {
            Object.entries(mapObj || {}).forEach(([key, val]) => {
                let x = parseInt(key.split('y')[0].split('x')[1]);
                let y = parseInt(key.split('y')[1]);
                if (isNaN(x) || isNaN(y)) return;
                let yV = y_fields - y - 1;
                let bounds = isTop
                    ? getNorthBounds(x, yV, sizeOfMarker, margin, tw, th)
                    : getWestBounds(x, yV, sizeOfMarker, margin, tw, th);
                drawRectangle(bounds, this.layer.getSource(), true, 2,
                    this.colorFor(val.mag_px, minV, maxV), "", textColor);
            });
        };

        plot(seamDistortion.top, true);
        plot(seamDistortion.left, false);
        resolve();
    });
}

export default SeamDistortion;
